import React from 'react';
import './HeroDescription.css';

export function HeroDescription() {
  return (
    <div className="hero-description">
      <p className="hero-description__line hero-description__line--bold">
        명확한 올인원 리포트와 함께하는 데이터 기반 분석
      </p>
      <p className="hero-description__line">
        모든 궁사가 더 높은 점수를 쏠 수 있도록 완벽한 파트너가 되어드립니다
      </p>
    </div>
  );
}
